




import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import { EventBus } from "@/event-bus";

@Component
export default class LoggedOnComponent extends Vue {
  private readonly NOT_LOGGED_ON_PERSON_NAME: string = "niet ingelogd";

  private displayValue: string = this.NOT_LOGGED_ON_PERSON_NAME;

  private personName: string = "";

  private uziPassLabel: string = "";

  public created() {
    EventBus.$on("SecurityService_loggedon_user_updated", () => {
      this.assignValues();
    });
  }

  public mounted() {
    //Also assign values when reloading the component instead of only when the loggedon user event triggers
    this.assignValues();
  }

  assignValues() {
    if (SecurityService.getInstance().isLoggedOn()) {
      this.personName = SecurityService.getInstance().personName;
      this.uziPassLabel = SecurityService.getInstance().uziPassLabel;

      this.displayValue = this.personName;
      if (
        this.uziPassLabel !== undefined &&
        this.uziPassLabel !== null &&
        this.uziPassLabel !== ""
      ) {
        this.displayValue += " (" + this.uziPassLabel + ")";
      }
    } else {
      this.personName = "";
      this.uziPassLabel = "";
      this.displayValue = this.NOT_LOGGED_ON_PERSON_NAME;
    }
  }
}
